import { getApiData, getNewApiData } from "../utils/APIHelper";

const PAYMENT_GROUP_ENDPOINTS = {
  UPDATE_PAYMENT_GROUP: "api/v2/project/payment-group",
  DELETE_PAYMENT_GROUP: (groupId) => `api/v2/project/payment-group/${groupId}`,
};

/**
 * Update payment group with linked milestones
 * @param {Object} body - Payment group data
 * @param {Array} body.milestones - Array of milestone objects with milestoneId
 * @param {Object} body.paymentGroup - Payment group details
 * @returns {Promise} API response
 */
export const updatePaymentGroup = async (body) => {
  try {
    const response = await getNewApiData(
      PAYMENT_GROUP_ENDPOINTS.UPDATE_PAYMENT_GROUP,
      "PUT",
      body,
      { "Content-Type": "application/json" },
      true
    );
    return response;
  } catch (error) {
    console.error("Error updating payment group:", error);
    throw error;
  }
};

/**
 * Delete a payment group
 * @param {string} groupId - Payment group ID
 * @returns {Promise} API response
 */
export const deletePaymentGroup = async (groupId) => {
  try {
    const response = await getNewApiData(
      PAYMENT_GROUP_ENDPOINTS.DELETE_PAYMENT_GROUP(groupId),
      "DELETE",
      {},
      { "Content-Type": "application/json" },
      true
    );
    return response;
  } catch (error) {
    console.error("Error deleting payment group:", error);
    throw error;
  }
};
